import type { ReactNode } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { HelpCircle } from 'lucide-react';

export function TooltipProvider({ children }: { children: ReactNode }) {
  return <RadixTooltip.Provider delayDuration={200}>{children}</RadixTooltip.Provider>;
}

/** Inline "What's this?" helper for an unavoidable technical term. */
export function WhatsThis({ children }: { children: ReactNode }) {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>
        <button
          type="button"
          aria-label="What's this?"
          className="inline-flex align-middle text-ink-faint hover:text-brand"
        >
          <HelpCircle size={14} />
        </button>
      </RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          sideOffset={6}
          className="z-50 max-w-xs rounded-lg border border-border bg-surface-raised px-3 py-2 text-xs text-ink shadow-lg"
        >
          {children}
          <RadixTooltip.Arrow className="fill-surface-raised" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
